import * as React from "react";
import { IExplorerProperties, IDataEntityResponse, IColumnMap } from "../../models";
import { ExplorerTabContent } from '../ExplorerTabContent';
import { WatchlistButton } from '../WatchlistButton';
import { Disclaimer } from "../../assets/";
import { BackToTop } from "../../assets/BackToTop/BackToTop";

const FaPDF = require('react-icons/lib/fa/file-pdf-o');
const FaAngleRight = require('react-icons/lib/fa/angle-right');
const styles = require('../FundPages/Fundpages.pcss');
const tabStyles = require('./FundExplorerTabs.pcss');
const backToTopstyles = require('./overrides/BackToTopoverride.pcss');

interface IProps {
    groupedRows: any[];
}

export class ExplorerTabYield extends React.Component<IProps & IExplorerProperties, {}>{

    constructor(props) {
        super(props)
    }

    getColumns() {
        let { appParams, editWatchlist, watchlist } = this.props;
        let { productrange, region } = appParams;

        let columns: IColumnMap[] = [
            {
                headerKey: 'Share Class',
                field: 'properties.shareclass_display',
                type: 'string',
                className: tabStyles.firstColumn
            },
            {
                headerKey: 'Watchlist',
                type: 'component',
                viewRestriction: 'table',
                component: <WatchlistButton appParams={ appParams } watchlist={watchlist} editWatchlist={editWatchlist}></WatchlistButton>,
                getPropsFn: (row, groupedRow) => {
                    return {
                        fundName: groupedRow.display,
                        fundIdentifier: groupedRow.fund.clientCode,
                        isin: row.clientCode
                    };
                },
                headerClassName: tabStyles.watchListColumn
            }
        ];
        return columns;
    }

    render() {
        let { funds, toggleFund, toggleAllFunds, isLoading, groupedRows, toggleShareClass, toggleShareClassPerformance } = this.props;
        return (
            <ExplorerTabContent
                isLoading={ isLoading }
                funds={ funds }
                groupedRows={ groupedRows }
                columns={ this.getColumns() }
                toggleFund={ toggleFund }
                toggleShareClass={ toggleShareClass }
                toggleShareClassPerformance={ toggleShareClassPerformance } />
        );
    }
}




// WEBPACK FOOTER //
// ./src/client/components/FundExplorerTabs/FundExplorerYieldTab.tsx